import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import hero1 from '../assets/hero1.jpg'
import hero2 from '../assets/hero2.jpg'
import hero3 from '../assets/hero3.jpeg'

const slides = [
  { img: hero1, tag: 'Founded in 1980 · Karnal, Haryana', lines: ['Serving Humanity', 'Through Community', 'Action'], hi: 1, sub: 'A non-profit organization working for the welfare of the people of Haryana through education, health, and social service.' },
  { img: hero2, tag: '1,200+ Dedicated Volunteers', lines: ['Building a Better', 'Haryana,', 'Together'], hi: 1, sub: 'We run schools, hospitals, vocational centers, and hostels — serving the poor and needy without discrimination of caste or creed.' },
  { img: hero3, tag: '46 Years of Selfless Service', lines: ['Compassion in Action', 'Across Every', 'District'], hi: 2, sub: 'With 520+ projects spanning 27 districts, we bring hope and dignity to thousands of families across Haryana every single day.' },
]

export default function Hero() {
  const [cur, setCur] = useState(0)
  const [fading, setFading] = useState(false)

  useEffect(() => {
    const t = setInterval(() => change((cur + 1) % slides.length), 6000)
    return () => clearInterval(t)
  })

  const change = (i) => {
    setFading(true)
    setTimeout(() => { setCur(i); setFading(false) }, 350)
  }

  const s = slides[cur]

  return (
    <section className="relative w-full overflow-hidden" style={{height:'92vh',minHeight:'560px'}}>
      {/* Background slides */}
      {slides.map((sl, i) => (
        <div key={i} className="absolute inset-0 transition-opacity duration-1000" style={{opacity: i === cur ? 1 : 0, zIndex: i === cur ? 1 : 0}}>
          <img src={sl.img} alt="" className="w-full h-full object-cover"/>
          <div className="absolute inset-0" style={{background:'linear-gradient(110deg, rgba(13,27,62,0.92) 0%, rgba(13,27,62,0.65) 55%, rgba(0,0,0,0.18) 100%)'}}/>
        </div>
      ))}

      {/* Grid overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{zIndex:2,backgroundImage:'linear-gradient(rgba(255,255,255,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.025) 1px,transparent 1px)',backgroundSize:'64px 64px'}}/>

      {/* Content */}
      <div className="absolute inset-0 flex items-center" style={{zIndex:10}}>
        <div className="max-w-7xl mx-auto w-full px-6 sm:px-8">
          <div style={{transition:'opacity 0.35s,transform 0.35s', opacity: fading ? 0 : 1, transform: fading ? 'translateY(12px)' : 'translateY(0)'}}>

            {/* Eyebrow */}
            <div className="inline-flex items-center gap-2.5 rounded-full px-4 py-1.5 mb-7" style={{background:'rgba(232,103,10,0.18)',border:'1px solid rgba(232,103,10,0.32)'}}>
              <span className="w-1.5 h-1.5 rounded-full pulse-dot" style={{background:'#FFA55A'}}/>
              <span className="text-[11px] font-semibold tracking-widest uppercase" style={{color:'#FFA55A'}}>{s.tag}</span>
            </div>

            {/* Title */}
            <h1 className="font-bold mb-6 leading-[1.1] text-white" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(36px,5.5vw,66px)'}}>
              {s.lines.map((line, i) => (
                <span key={i} className="block" style={{color: i === s.hi ? 'var(--saffron-light)' : 'white'}}>{line}</span>
              ))}
            </h1>

            {/* Sub */}
            <p className="mb-9 leading-relaxed max-w-xl" style={{fontSize:'16px',color:'rgba(255,255,255,0.62)'}}>{s.sub}</p>

            {/* CTAs */}
            <div className="flex items-center gap-4 flex-wrap">
              <Link to="/about" className="inline-flex items-center gap-2 text-white px-7 py-3.5 rounded-full font-semibold text-sm transition-all duration-200 hover:-translate-y-0.5"
                style={{background:'var(--saffron)',border:'2px solid var(--saffron)'}}>
                Our Story
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
              </Link>
              <Link to="/initiatives" className="inline-flex items-center gap-2 text-white px-7 py-3.5 rounded-full font-medium text-sm transition-all duration-200"
                style={{border:'1.5px solid rgba(255,255,255,0.28)'}}>
                Our Initiatives
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
              </Link>
            </div>

            {/* Stats */}
            <div className="flex items-center gap-10 mt-12 pt-10 flex-wrap" style={{borderTop:'1px solid rgba(255,255,255,0.10)'}}>
              {[['1,200+','Volunteers'],['520+','Projects'],['27','Districts'],['46+','Years']].map(([v,l]) => (
                <div key={l}>
                  <div className="font-bold leading-none" style={{fontFamily:'Playfair Display,serif',fontSize:'28px',color:'var(--saffron-light)'}}>{v}</div>
                  <div className="text-xs mt-1 tracking-wide" style={{color:'rgba(255,255,255,0.4)'}}>{l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Arrow buttons */}
      {['prev','next'].map(dir => (
        <button key={dir} onClick={() => change(dir === 'prev' ? (cur - 1 + slides.length) % slides.length : (cur + 1) % slides.length)}
          className="absolute top-1/2 -translate-y-1/2 w-11 h-11 rounded-full flex items-center justify-center text-white transition-all duration-200"
          style={{zIndex:20, [dir === 'prev' ? 'left' : 'right']:'16px', background:'rgba(255,255,255,0.10)', border:'1px solid rgba(255,255,255,0.18)'}}>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <polyline points={dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6'}/>
          </svg>
        </button>
      ))}

      {/* Dots */}
      <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-2" style={{zIndex:20}}>
        {slides.map((_, i) => (
          <button key={i} onClick={() => change(i)} className="rounded-full border-none cursor-pointer transition-all duration-300"
            style={{height:'8px', width: i === cur ? '28px' : '8px', background: i === cur ? 'var(--saffron)' : 'rgba(255,255,255,0.35)'}}/>
        ))}
      </div>
    </section>
  )
}
